'use client';

// Supabase detached - stub service

export interface DiscoveryCallFormData {
  full_name: string;
  email: string;
  phone: string;
  company: string;
  job_title: string;
  company_size: string;
  industry: string;
  ai_initiative: string;
  timeline: string;
  challenges?: string;
  preferred_date: string;
  preferred_time: string;
}

export const crmService = {
  async submitDiscoveryCall(_data: DiscoveryCallFormData) { return { success: true }; },
  async getDiscoveryCalls() { return []; },
  async updateDiscoveryCall(_id: string, _data: Partial<DiscoveryCallFormData>) { return null; },
};
function createDiscoveryCall(...args: any[]): any {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: createDiscoveryCall is not implemented yet.', args);
  return null;
}

export { createDiscoveryCall };
function createPartnerApplication(...args: any[]): any {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: createPartnerApplication is not implemented yet.', args);
  return null;
}

export { createPartnerApplication };